export const T = {
  en_GB: { loadingGoal: "Loading goal information..." },
  nb_NO: { loadingGoal: "Laster målinformasjon..." },
} as const;
